import { useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STATUSES = [
  { value: "RECEIVED", label: "Received" },
  { value: "SHIPPED", label: "Shipped" },
  { value: "IN_TRANSIT", label: "In Transit" },
  { value: "OUT_FOR_DELIVERY", label: "Out for Delivery" },
  { value: "DELIVERED", label: "Delivered" },
];

const UpdateStatusForm = ({ shipment, onSuccess }) => {
  const token = localStorage.getItem("token");
  const axiosAuth = axios.create({
    headers: { Authorization: `Bearer ${token}` },
  });
  const [status, setStatus] = useState(shipment.status);
  const [location, setLocation] = useState("");
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axiosAuth.put(`${API}/shipments/${shipment.id}/status`, {
        status,
        location,
        notes,
      });
      toast.success("Status updated!");
      onSuccess();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to update status");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <p className="font-mono text-sm text-slate-500 mb-4">{shipment.tracking_number}</p>
      </div>
      <div>
        <Label className="text-xs uppercase tracking-widest">Status</Label>
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger data-testid="status-select">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {STATUSES.map((s) => (
              <SelectItem key={s.value} value={s.value}>
                {s.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-xs uppercase tracking-widest">Location</Label>
        <Input
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          placeholder="Current location"
          required
          data-testid="location-input"
        />
      </div>
      <div>
        <Label className="text-xs uppercase tracking-widest">Notes (Optional)</Label>
        <Textarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Additional notes..."
          rows={2}
          data-testid="notes-input"
        />
      </div>
      <Button
        type="submit"
        disabled={loading}
        className="w-full bg-amber-500 hover:bg-amber-600 text-slate-900 font-bold uppercase tracking-widest"
        data-testid="update-status-btn"
      >
        {loading ? "Updating..." : "Update Status"}
      </Button>
    </form>
  );
};

export default UpdateStatusForm;
